export enum ASSET_TYPES {
  TENANT = "TENANT",
  CUSTOMER = "CUSTOMER",
  LOCATION = "LOCATION",
  BUILDING = "BUILDING",
  GATE_SYSTEM = "GATE_SYSTEM",
}

export type AssetType = `${ASSET_TYPES}`;
